import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { UnarchiveItemDialog } from '@/features/inventory/admin/UnarchiveItemDialog'
import { type UnarchiveItemDialogViewModel } from './UnarchiveItemDialogViewModel'

export interface UnarchiveItemDialogContainerProps {
  vm: UnarchiveItemDialogViewModel
}

export const UnarchiveItemDialogContainer = observer(
  function UnarchiveItemDialogContainer({
    vm,
  }: UnarchiveItemDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))

    return (
      <UnarchiveItemDialog
        showing={vm.modal.showing}
        onClose={vm.cancel}
        onUnarchive={vm.unarchive}
        isUnarchivePending={vm.unarchive.pending}
        isOverride={vm.inventoryItem?.override}
        inventoryItemName={vm.inventoryItem?.name}
        workspaceName={vm.inventoryItem?.workspace?.name}
        corporateMode={shellInfo.corporateMode}
        testId="inventory-items"
      />
    )
  },
)
